
const digest = '1ae049d178effd7f985258da851d82524763290030d250b02d39726a7e8861c1';
const classes = {"text":"_text_1tex8_1","textBold":"_textBold_1tex8_5"};
const css = `._text_1tex8_1 {
  font-size: 14px;
}

._textBold_1tex8_5 {
  font-size: 14px;
  font-weight: 500;
  margin-top: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  